module.exports = __webpack_public_path__ + "img/billing-icon.46dbff71.svg";